var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"write"},[_vm._v("请使用微信扫描二维码填写满意度评价")]),_c('div',{ref:"qrCodeUrl",attrs:{"id":"qrCodeUrl"}})])}
var staticRenderFns = []

export { render, staticRenderFns }